class Zaikosys{
  _buyItNowFlg = 0;
  _masked = true;
  _pid = null;
  _myId = null;
  $form = document.querySelector('product-form');
  $dummyBuyItNow = document.getElementById('dummyBuyItNow');
  $dummyAddCartBtn = document.querySelector('#dummy_add_cart')
  $dynamicPaymentButton = document.querySelector(".dynamic-payment-button");
  $select = document.querySelector('.product-form__single-selector');
  $mask = document.querySelector('.mfn-initial-mask');
  title_to_sku = {}
  sku_to_variantId = {}
  constructor(){
    this.init()
  }
  init(){
    const UA = window.navigator.userAgent.toLowerCase();
    if ( UA.includes('msie') || UA.includes('trident') ) {
      if(this.$dummyBuyItNow) this.$dummyBuyItNow.hidden = true ;
    }
    if(this.$dynamicPaymentButton) this.$dynamicPaymentButton.hidden=true;
    this.checkMasked();
    this.$form.dataset.masked = String(this._masked);
    this._myId = this.getCookie() || this.setMyId();
    this._pid = meta.product.vendor;
    const variants = meta.product.variants || [];
    variants.forEach(variant =>{
      this.title_to_sku[variant.public_title] = variant.sku;
      this.sku_to_variantId[variant.sku] = variant.id
    })
    if(variants.length === 1){
      delete this.$form.dataset.masked;
      this.$form.dataset.single="true";
      this._masked = false;
    }
    this.#lookStocks();
    this.addListener();
  }
  async #lookStocks(){
    const fd = new FormData();  
    fd.append('time_str', String(Date.now()));
    fd.append('product_id', this._pid);
    fd.append('title_sku_json', JSON.stringify( this.title_to_sku));
    fd.append('ajax_mode', 'look_stocks');
    fd.append('url', 'https://zaikosys.kenkengems.com/s_look_stocks.php');
    const result = await this.ajax(fd);
    if(result){
      const $option = document.getElementById('option_stock');
      if($option) {
        $option.innerHTML = result;
        $option.hidden=false
      }
    }
  }
  async #stockCheck(){
    try{
      if(!this.$select){
        console.error('Missing $select');
        throw new Error()
      }
      let selectedTitle;
      const params = new URL(location.href).searchParams;
      if(params.get('variant')){
        const _id = Number(params.get('variant'));
        if(!isNaN(_id)){
          const selected = meta.product.variants.find(v=>v.id === _id)
          selectedTitle = (selected) ? selected.public_title :"";
        }
      }
      if(!selectedTitle){
        const children = this.$select.options;
        const selected = [...children].find(o =>o.selected === true);
        selectedTitle = selected.textContent;
      }
      // console.log("DEBUG title", selectedTitle)

      const SKU = this.title_to_sku[selectedTitle];
      // console.log('DEBUG SKU', SKU)
      if(!SKU || SKU ===undefined){
        throw new Error('Please select variant!')
      }
      const selectedId = this.sku_to_variantId[SKU];
      // console.log('DEBUG variId', selectedId)
      if(!selectedId || selectedId===undefined){
        console.error('cannot get selectedId')
        throw new Error()
      }
      const $num = document.querySelector('[name="quantity"]')
      const NUM = ($num) ? $num.value : 1;
      const fd = new FormData()
      fd.append('s_myid', this.checkMyId());
      fd.append('sku', SKU);
      fd.append('variant_id', selectedId);
      fd.append('num', NUM);
      fd.append('buyItNowFlg', this._buyItNowFlg);
      fd.append('ajax_mode', 'stock_check_product');
      fd.append('url', 'https://zaikosys.kenkengems.com/new_s_stock_check.php');
      const response = await this.ajax(fd);
      if(!response){
        throw new Error('Network Error')
      }
      const result = response.toUpperCase();
      // console.log('DEBUG result', result)
      if (result.includes('OK')) {
        if (this._buyItNowFlg) {
          if(this.$dynamicPaymentButton) this.$dynamicPaymentButton.click()
        } else {
          const $submitBtn = document.querySelector('#real_add_cart')
          if($submitBtn){
            $submitBtn.click()
          }else{
            console.error('missing $submitBtn')
          }
        }
      } else if (result.includes('OVER')) {
        throw new Error('The quantity is more than the stocks.');
      } else {
        throw new Error('unexpected error occurred.');
      }
    }catch(e){
      const msg = (e?.message) ? e.message : "Error occurred";
      alert(msg)
    }
  } 
  addListener(){
    if(this.$form){
      this.$form.addEventListener('click', async(e)=>{
        const t = e.target;
        const $select = t.closest('.product-form__single-selector');
        const $dummyAddCart = t.closest('#dummy_add_cart');
        const $dummyBuyNow = t.closest('#dummyBuyItNow');
        if($select){
          this._masked = false;
          delete this.$form.dataset.masked;
        } else if( $dummyAddCart){
          if($dummyAddCart.getAttribute("aria-busy") === "true") return;
          if(this._masked) {
            alert('Please select variant!');
            return
          }
          $dummyAddCart.setAttribute("aria-busy", "true");
          this._buyItNowFlg = 0;
          await this.#stockCheck();
          $dummyAddCart.removeAttribute('aria-busy')    
        } else if( $dummyBuyNow){
          if($dummyBuyNow.getAttribute("aria-busy") === "true") return;
          if(this._masked) {
            alert('Please select variant!');
            return
          }
          $dummyBuyNow.setAttribute("aria-busy", "true");
          this._buyItNowFlg = 0;
          await this.#stockCheck();
          $dummyBuyNow.removeAttribute('aria-busy')    
        }
      })
    }
    // if(this.$select && this.$mask && this._masked){
    //   this.$select.addEventListener('click',()=>{
    //     if(this.$mask) this.$mask.remove();
    //     this._masked = false;
    //     if(this.$dummyAddCartBtn) this.$dummyAddCartBtn.disabled = false;
    //   })
    // }
    // if( this.$dummyBuyItNow){
    //   this.$dummyBuyItNow.addEventListener('click', async(e)=>{
    //     if(this._masked) {
    //       alert('Please select variant!');
    //       return
    //     }
    //     const t = e.currentTarget;
    //     if(t.getAttribute("aria-busy") === "true") return;
    //     t.setAttribute("aria-busy", "true");
    //     this._buyItNowFlg = 1;
    //     await this.#stockCheck();
    //     t.removeAttribute('aria-busy')
    //   })
    // }
    // if(this.$dummyAddCartBtn){
    //   this.$dummyAddCartBtn.addEventListener('click', async(e) =>{
    //     if(this._masked) {
    //       alert('Please select variant!');
    //       return
    //     }
    //     const t = e.currentTarget;
    //     if(t.getAttribute("aria-busy") === "true") return;
    //     t.setAttribute("aria-busy", "true");
    //     this._buyItNowFlg = 0;
    //     await this.#stockCheck();
    //     t.removeAttribute('aria-busy')
    //   })
    // }
    const $num = document.querySelector('[name="quantity"]')
    if($num){
      $num.addEventListener('keydown', (e)=>{
        const key = e.key;
        if(key !== "Enter") return;
        e.preventDefault()
      })
    }
    document.addEventListener('variant:change', () => {// wishListの増殖を防ぐ
      const wishBtn = this.$form.querySelector('.wk-button');
      if(wishBtn) wishBtn.remove()
    })     

    // document.addEventListener('variant:change', () => {    
    //   const observer = new MutationObserver((mutations) => {
    //     console.log(mutations[0])
    //     // this.checkMasked();
    //   });
    
    //   observer.observe( this.$form, {
    //     childList: true,
    //     subtree: true,
    //   });
    // });
  }
  async ajax(formData){
    try{
      const URL = formData.get('url');
      if(!URL){
        throw new Error('missing url')
      }
      const res = await fetch(URL, {
        method: "POST",
        body: formData
      })
      const restext = await res.text()
      if(!res.ok){
        throw new Error(`[${res.status}] ${restext}`)                
      }
      return restext

    }catch(e){
      console.error(e);
      alert()
      return null
    }
  }
  checkMyId(){
    return (this._myId) ? this._myId : this.setMyId();
  }
  setMyId(){
    const cookieKey = "s_myid";
    const random = Math.random().toString(36).slice(2, 16);
    const s_myid = String(Date.now()) + random;
    document.cookie = `${cookieKey}=${s_myid}; path="/";`;
    this._myId = s_myid;
    return s_myid
  }
  getCookie(key = "s_myid"){
    const match = document.cookie.match(new RegExp('(^|;)\\s*' + key + '=([^;]*)'));
    return (match && match[2]) ? decodeURIComponent(match[2]) : null;
  }
  checkMasked(){
    const url = new URL(location.href);
    const params = url.searchParams;
    const isVariant = params.get('variant');
    if( isVariant && !isNaN( Number(isVariant))){
      this._masked = false;
    }else{
      this._masked = true
    }
  }
}
document.addEventListener('DOMContentLoaded', ()=> new Zaikosys())
